import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import type React from 'react';
import styled from 'styled-components';
import { TYPES } from '@/engine/ioc';
import type { ObjectsListController } from './ObjectsList.controller';

export const ObjectsList: React.FC = observer(() => {
  const controller = useInjection<ObjectsListController>(TYPES.ObjectsListController);

  return (
    <Container>
      <List component="nav">
        {controller.objects?.map((object) => {
          return (
            <ListItemButton key={object.descriptor} onClick={(): void => controller.toggleObjectVisibility(object)}>
              <ListItemText>
                {object.label} <span style={{ fontWeight: 'bold' }}>{object.isVisible ? 'on' : 'off'}</span>
              </ListItemText>
            </ListItemButton>
          );
        })}
      </List>
    </Container>
  );
});

const Container = styled.div``;
